
import * as $ from 'jquery';
import 'jquery-match-height'; // Import the matchHeight plugin

export const matchHeights = () => {
    $(document).ready(function() {
        $('.posts__top-wrap').matchHeight();
    });
}
